<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <v-dialog v-model="dialogEmpleado" persistent max-width="750px">
      <v-card>
        <v-form ref="fEmpleado">
          <v-card-title class="px-4 py-6">
            <span class="text-h5">Datos del Empleado</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="2" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.codigoEmpleado"
                    label="Código"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.nombres"
                    label="Nombres"
                    dense
                    :rules="requiredRule"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.apellidos"
                    label="Apellidos"
                    :rules="requiredRule"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0 pt-2 px-1 ma-0">
                  <v-textarea
                    outlined
                    no-resize
                    dense
                    rows="2"
                    v-model="selectedEmpleado.direccion"
                    label="Dirección"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.telefono"
                    label="Telefono"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.correo"
                    dense
                    label="Correo"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="py-0 px-1 ma-0 text-center d-flex justify-center"
                >
                  <v-switch
                    v-model="selectedEmpleado.genero"
                    dense
                    inset
                    class="pt-0 mt-3"
                    color="primary"
                    :label="selectedEmpleado.genero ? 'Masculino' : 'Femenino'"
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.fechaNacimiento"
                    label="Fecha Nacimiento"
                    type="date"
                    dense
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.fechaContratacion"
                    label="Fecha Contratacion"
                    type="date"
                    dense
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0 px-1 ma-0">
                  <v-autocomplete
                    v-model="selectedEmpleado.departamentoId"
                    label="Departamento"
                    :items="departamentos"
                    item-text="departamento"
                    dense
                    item-value="id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="py-0 px-1 ma-0">
                  <v-autocomplete
                    v-model="selectedEmpleado.posicionId"
                    label="Posicion"
                    :items="posiciones"
                    item-text="posicion"
                    dense
                    item-value="id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.nombreEmergencia"
                    dense
                    label="Persona Contacto Emergencia"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.telefonoEmergencia1"
                    dense
                    label="#Emergencia"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.telefonoEmergencia2"
                    dense
                    label="#Emergencia 2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model="selectedEmpleado.fechaDespido"
                    label="Fecha Despido"
                    type="date"
                    dense
                    clearable
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" class="py-0 px-1 ma-0">
                  <v-textarea
                    outlined
                    no-resize
                    dense
                    rows="4"
                    v-model="selectedEmpleado.razonDespido"
                    label="Razon Despido"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text outlined @click="limpiar">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" dark @click="guardar"> Guardar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row justify="space-between" align="center">
      <v-col cols="12">
        <h2 class="px-3">Empleados</h2>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-spacer></v-spacer>
      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="listar"
            >
              Listar
            </v-btn>
          </template>
          <span>Listar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="downloadReporte"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1"> Empleados</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row>
                <v-col class="pt-0 pl-4" cols="12" md="4">
                  <v-text-field
                    class="text-xs-center"
                    v-model="search"
                    dense
                    append-icon="search"
                    label="Búsqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" class="pt-0">
                  <v-switch
                    v-model="soloActivos"
                    class="pt-0 mt-2"
                    inset
                    :label="soloActivos == 1 ? 'Solo Activos' : 'Todos'"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="2" class="pt-0 pl-4">
                  <v-btn
                    class="mx-2"
                    dark
                    color="primary"
                    @click="dialogEmpleado = true"
                  >
                    Agregar
                    <v-icon dark small class="pl-1"> fa-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headerGeneral"
                :items="filteredHistorial"
                :loading="loader"
                loading-text="Listando Datos..."
                no-data-text="No se encontraron resultados..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.opciones`]="{ item }">
                  <v-icon class="mr-4" @click="verDetalles(item)"> tab </v-icon>
                  <v-icon
                    @click="toggleEmployeeState(item.id)"
                    :color="item.estado == 1 ? 'red' : 'green'"
                  >
                    {{ item.estado == 1 ? "block" : "check" }}
                  </v-icon>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="item.estado ? 'green' : 'red'" dark>
                    {{ item.estado ? "Activo" : "Inactivo" }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

export default {
  name: "EmpleadoMarcaciones",
  data() {
    return {
      step: 1,
      snack: false,
      requiredRule: [(v) => !!v || "Campo obligatorio"],
      menuFechaNacimiento: false,
      menuFechaContratacion: false,
      menuFechaDespido: false,
      selectedEmpleado: {
        id: null,
        codigoEmpleado: null,
        nombres: null,
        apellidos: null,
        direccion: null,
        fechaNacimiento: null,
        departamentoId: null,
        posicionId: null,
        telefono: null,
        fechaContratacion: null,
        fechaDespido: null,
        razonDespido: null,
        telefonoEmergencia1: null,
        telefonoEmergencia2: null,
        nombreEmergencia: null,
        correo: null,
        genero: false,
        estado: 1,
      },
      dialogEmpleado: false,
      snackColor: "primary",
      snackTime: 4000,
      calculoBeta: false,
      snackText: "Notification",
      departamentos: [],
      posiciones: [],
      historial: [],
      codigoEmpleado: null,
      loader: false,
      search: "",
      soloActivos: false,
      historialSoloActivos: [],
      headerGeneral: [
        {
          text: "Código",
          value: "codigoEmpleado",
          width: 200,
          align: "center",
          sortable: true,
        },
        {
          text: "Nombres",
          value: "nombres",
          align: "center",
          sortable: true,
        },
        {
          text: "Apellidos",
          value: "apellidos",
          align: "center",
          sortable: true,
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          sortable: true,
          width: 200,
        },
        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  created() {
    const tienePermiso = this.$store.state.permisos.some(
      (permiso) => permiso.nombre_modulo == "Marcaciones"
    );

    if (!tienePermiso) {
      this.$router.go(-1);
    }

    this.listar();
    this.listarComboBox();
  },
  computed: {
    filteredHistorial() {
      return this.soloActivos ? this.historialSoloActivos : this.historial;
    },
  },
  methods: {
    toggleEmployeeState(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(`api/Marcaciones/Employee/State/${id}`, {}, configuracion)
        .then((res) => {
          this.snackText = "Empleado Actualizado!";
          this.snackColor = "primary";
          this.snack = true;

          this.limpiar();
          this.listar();
        })
        .catch((err) => {
          console.error(err);

          this.snackText = "No se Pudo Actualizar Empleado";
          this.snackColor = "error";
          this.snack = true;
        });
    },
    nuevoEmpleado() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fEmpleado.validate()) {
        axios
          .post(
            "api/Marcaciones/Employee",
            this.selectedEmpleado,
            configuracion
          )
          .then((res) => {
            this.snackText = "Nuevo Empleado Creado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);
            this.snackText = "No se Pudo Crear El Empleado";
            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    actualizarEmpleado() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fEmpleado.validate()) {
        axios
          .put(
            `api/Marcaciones/Employee/${this.selectedEmpleado.id}`,
            this.selectedEmpleado,
            configuracion
          )
          .then((res) => {
            this.snackText = "Empleado Actualizado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Actualizar Empleado";
            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    guardar() {
      if (!this.selectedEmpleado?.id) {
        this.nuevoEmpleado();
      } else {
        this.actualizarEmpleado();
      }
    },
    limpiar() {
      this.selectedEmpleado = {
        id: null,
        codigoEmpleado: null,
        nombres: null,
        apellidos: null,
        direccion: null,
        fechaNacimiento: null,
        departamentoId: null,
        posicionId: null,
        telefono: null,
        fechaContratacion: null,
        fechaDespido: null,
        razonDespido: null,
        telefonoEmergencia1: null,
        telefonoEmergencia2: null,
        nombreEmergencia: null,
        correo: null,
        genero: false,
        estado: 1,
      };

      this.dialogEmpleado = false;

      if (this.$refs.fEmpleado) {
        this.$refs.fEmpleado.resetValidation();
      }
    },
    verDetalles(item) {
      this.selectedEmpleado = { ...item };
      this.dialogEmpleado = true;

      if (item.fechaContratacion) {
        this.selectedEmpleado.fechaContratacion = new Date(
          item.fechaContratacion
        ).toLocaleDateString("en-CA");
      }

      if (item.fechaNacimiento) {
        this.selectedEmpleado.fechaNacimiento = new Date(
          item.fechaNacimiento
        ).toLocaleDateString("en-CA");
      }

      if (item.fechaDespido) {
        this.selectedEmpleado.fechaDespido = new Date(
          item.fechaDespido
        ).toLocaleDateString("en-CA");
      }
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Marcaciones/Department", configuracion)
        .then((res) => {
          this.departamentos = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/Marcaciones/Position", configuracion)
        .then((res) => {
          this.posiciones = res.data;
        })
        .catch((err) => console.error(err));
    },
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Marcaciones/Employee", configuracion)
        .then((res) => {
          this.historial = res.data;

          this.historialSoloActivos = this.historial.filter(
            (emp) => emp.estado == 1
          );
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    downloadReporte() {
      const workbook = XLSX.utils.book_new();

      const filteredData = this.filteredHistorial.map((emp) => {
        const helper = { ...emp };

        helper.estado = helper.estado == 1 ? "Activo" : "Inactivo";
        helper.genero = helper.genero == 1 ? "Masculino" : "Femenino";
        helper.departamento = helper.departamento?.toUpperCase();

        delete helper.id;
        delete helper.posicionId;
        delete helper.departamentoId;

        return helper;
      });

      const data = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(workbook, data, "Empleados");

      const filename = "Empleados.xlsx";
      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
